import { RangeColor } from '@/types';

const regularHoursLoggedRanges = [
  { range: [16.0, 24.0], color: 'var(--range-green-low)' },
  { range: [12.0, 16.0], color: 'var(--range-red-low)' },
  { range: [8.0, 12.0], color: 'var(--range-green-high)' },
  { range: [0, 8.0], color: 'var(--range-yellow-medium)' },
];

const doubleTimeHoursLoggedRanges = [
  { range: [23.0, 50.0], color: 'var(--range-red-medium)' },
  { range: [2.0, 23.0], color: 'var(--range-green-medium)' },
  { range: [0, 2.0], color: 'var(--range-yellow-medium)' },
];

const overtimeHoursLoggedRanges = [
  { range: [9.0, 24.0], color: 'var(--range-red-low)' },
  { range: [8.0, 9.0], color: 'var(--range-yellow-high)' },
  { range: [6.0, 8.0], color: 'var(--range-red-medium)' },
  { range: [4.0, 6.0], color: 'var(--range-green-medium)' },
  { range: [3.0, 4.0], color: 'var(--range-yellow-low)' },
  { range: [0, 3.0], color: 'var(--range-green-high)' },
];

const totalHoursLoggedRanges = [
  { range: [20.0, 24.0], color: 'var(--range-red-high)' },
  { range: [16.0, 20.0], color: 'var(--range-yellow-high)' },
  { range: [12.5, 16.0], color: 'var(--range-green-medium)' },
  { range: [12.0, 12.5], color: 'var(--range-green-low)' },
  { range: [10.0, 12.0], color: 'var(--range-yellow-high)' },
  { range: [0, 10.0], color: 'var(--range-green-high)' },
];

const workedDayShiftRanges = [
  { range: [1.0, 7.0], color: 'var(--range-red-high)' },
  { range: [0, 1.0], color: 'var(--range-green-high)' },
];

const workedNightShiftRanges = [
  { range: [1.0, 6.0], color: 'var(--range-red-high)' },
  { range: [0, 1.0], color: 'var(--range-green-high)' },
];

const cumulativeRegularHoursRanges = [
  { range: [1331.0, 13921.0], color: 'var(--range-green-high)' },
  { range: [736.0, 1331.0], color: 'var(--range-green-medium)' },
  { range: [540.0, 736.0], color: 'var(--range-yellow-low)' },
  { range: [432.0, 540.0], color: 'var(--range-yellow-low)' },
  { range: [352.0, 432.0], color: 'var(--range-yellow-high)' },
  { range: [292.0, 352.0], color: 'var(--range-green-low)' },
  { range: [240.0, 292.0], color: 'var(--range-yellow-medium)' },
  { range: [208.0, 240.0], color: 'var(--range-red-high)' },
  { range: [164.0, 208.0], color: 'var(--range-yellow-high)' },
  { range: [136.0, 164.0], color: 'var(--range-yellow-high)' },
  { range: [105.0, 136.0], color: 'var(--range-red-high)' },
  { range: [80.0, 105.0], color: 'var(--range-yellow-high)' },
  { range: [52.0, 80.0], color: 'var(--range-yellow-medium)' },
  { range: [32.0, 52.0], color: 'var(--range-yellow-low)' },
  { range: [0, 32.0], color: 'var(--range-green-low)' },
];

const cumulativeDoubleTimeHoursRanges = [
  { range: [198.0, 2073.75], color: 'var(--range-green-high)' },
  { range: [125.0, 198.0], color: 'var(--range-green-high)' },
  { range: [96.0, 125.0], color: 'var(--range-yellow-medium)' },
  { range: [72.0, 96.0], color: 'var(--range-red-low)' },
  { range: [60.0, 72.0], color: 'var(--range-red-low)' },
  { range: [48.0, 60.0], color: 'var(--range-green-medium)' },
  { range: [40.0, 48.0], color: 'var(--range-red-high)' },
  { range: [24.0, 40.0], color: 'var(--range-yellow-low)' },
  { range: [20.0, 24.0], color: 'var(--range-red-high)' },
  { range: [8.0, 20.0], color: 'var(--range-yellow-medium)' },
  { range: [0, 8.0], color: 'var(--range-yellow-high)' },
];

const cumulativeOverTimeHoursRanges = [
  { range: [543.5, 3520.22], color: 'var(--range-green-high)' },
  { range: [364.0, 543.5], color: 'var(--range-yellow-low)' },
  { range: [280.0, 364.0], color: 'var(--range-green-low)' },
  { range: [224.0, 280.0], color: 'var(--range-green-low)' },
  { range: [184.0, 224.0], color: 'var(--range-yellow-medium)' },
  { range: [152.0, 184.0], color: 'var(--range-yellow-medium)' },
  { range: [124.0, 152.0], color: 'var(--range-yellow-medium)' },
  { range: [100.0, 124.0], color: 'var(--range-yellow-high)' },
  { range: [80.0, 100.0], color: 'var(--range-yellow-high)' },
  { range: [62.0, 80.0], color: 'var(--range-red-low)' },
  { range: [42.0, 62.0], color: 'var(--range-yellow-high)' },
  { range: [26.0, 42.0], color: 'var(--range-red-high)' },
  { range: [12.0, 26.0], color: 'var(--range-red-low)' },
  { range: [0, 12.0], color: 'var(--range-green-medium)' },
];

const cumulativeTotalHoursRanges = [
  { range: [2061.0, 18300.5], color: 'var(--range-green-high)' },
  { range: [1245.0, 2061.0], color: 'var(--range-green-medium)' },
  { range: [928.0, 1245.0], color: 'var(--range-yellow-high)' },
  { range: [742.0, 928.0], color: 'var(--range-yellow-medium)' },
  { range: [609.0, 742.0], color: 'var(--range-green-low)' },
  { range: [505.0, 609.0], color: 'var(--range-yellow-high)' },
  { range: [421.0, 505.0], color: 'var(--range-yellow-medium)' },
  { range: [348.0, 421.0], color: 'var(--range-green-low)' },
  { range: [285.0, 348.0], color: 'var(--range-red-high)' },
  { range: [226.5, 285.0], color: 'var(--range-red-high)' },
  { range: [175.0, 226.5], color: 'var(--range-red-low)' },
  { range: [128.0, 175.0], color: 'var(--range-red-low)' },
  { range: [84.0, 128.0], color: 'var(--range-yellow-high)' },
  { range: [48.0, 84.0], color: 'var(--range-green-low)' },
  { range: [0, 48.0], color: 'var(--range-green-medium)' },
];

const averageRegularHoursCumRanges = [
  { range: [16.4, 48.0], color: 'var(--range-yellow-medium)' },
  { range: [16.0, 16.4], color: 'var(--range-red-medium)' },
  { range: [14.316, 16.0], color: 'var(--range-yellow-high)' },
  { range: [13.385, 14.316], color: 'var(--range-yellow-high)' },
  { range: [12.821, 13.385], color: 'var(--range-red-low)' },
  { range: [12.364, 12.821], color: 'var(--range-red-medium)' },
  { range: [12.0, 12.364], color: 'var(--range-yellow-medium)' },
  { range: [11.429, 12.0], color: 'var(--range-red-medium)' },
  { range: [11.04, 11.429], color: 'var(--range-yellow-high)' },
  { range: [10.182, 11.04], color: 'var(--range-yellow-medium)' },
  { range: [8.0, 10.182], color: 'var(--range-green-medium)' },
  { range: [7.19, 8.0], color: 'var(--range-green-high)' },
  { range: [6.448, 7.19], color: 'var(--range-green-low)' },
  { range: [5.756, 6.448], color: 'var(--range-green-low)' },
  { range: [0, 5.756], color: 'var(--range-green-medium)' },
];

const averageDoubleTimeHoursCumRanges = [
  { range: [4.571, 48.0], color: 'var(--range-yellow-medium)' },
  { range: [3.75, 4.571], color: 'var(--range-yellow-low)' },
  { range: [3.286, 3.75], color: 'var(--range-yellow-medium)' },
  { range: [2.858, 3.286], color: 'var(--range-red-low)' },
  { range: [2.439, 2.858], color: 'var(--range-yellow-medium)' },
  { range: [2.058, 2.439], color: 'var(--range-yellow-high)' },
  { range: [1.741, 2.058], color: 'var(--range-yellow-low)' },
  { range: [1.426, 1.741], color: 'var(--range-red-high)' },
  { range: [1.071, 1.426], color: 'var(--range-green-low)' },
  { range: [0.636, 1.071], color: 'var(--range-green-medium)' },
  { range: [0.13, 0.636], color: 'var(--range-green-high)' },
  { range: [0, 0.13], color: 'var(--range-yellow-low)' },
];

const averageOverTimeHoursCumRanges = [
  { range: [9.6, 36.0], color: 'var(--range-green-low)' },
  { range: [9.059, 9.6], color: 'var(--range-red-low)' },
  { range: [8.593, 9.059], color: 'var(--range-red-low)' },
  { range: [8.0, 8.593], color: 'var(--range-yellow-medium)' },
  { range: [7.633, 8.0], color: 'var(--range-red-low)' },
  { range: [6.812, 7.633], color: 'var(--range-red-low)' },
  { range: [6.0, 6.812], color: 'var(--range-yellow-medium)' },
  { range: [5.107, 6.0], color: 'var(--range-red-high)' },
  { range: [4.382, 5.107], color: 'var(--range-yellow-low)' },
  { range: [3.882, 4.382], color: 'var(--range-green-medium)' },
  { range: [3.143, 3.882], color: 'var(--range-yellow-low)' },
  { range: [2.313, 3.143], color: 'var(--range-green-medium)' },
  { range: [1.199, 2.313], color: 'var(--range-green-low)' },
  { range: [0, 1.199], color: 'var(--range-green-high)' },
];

const averageTotalHoursCumRanges = [
  { range: [24.182, 48.8], color: 'var(--range-green-low)' },
  { range: [24.0, 24.182], color: 'var(--range-yellow-medium)' },
  { range: [23.833, 24.0], color: 'var(--range-red-low)' },
  { range: [23.348, 23.833], color: 'var(--range-yellow-high)' },
  { range: [22.784, 23.348], color: 'var(--range-yellow-medium)' },
  { range: [22.091, 22.784], color: 'var(--range-yellow-medium)' },
  { range: [21.333, 22.091], color: 'var(--range-yellow-high)' },
  { range: [20.4, 21.333], color: 'var(--range-red-high)' },
  { range: [19.8, 20.4], color: 'var(--range-yellow-high)' },
  { range: [17.4, 19.8], color: 'var(--range-red-high)' },
  { range: [12.0, 17.4], color: 'var(--range-green-high)' },
  { range: [11.373, 12.0], color: 'var(--range-green-low)' },
  { range: [10.479, 11.373], color: 'var(--range-green-medium)' },
  { range: [9.792, 10.479], color: 'var(--range-green-low)' },
  { range: [0.0, 9.792], color: 'var(--range-green-high)' },
];

const regularHoursVariabilityCumRanges = [
  { range: [8.0, 28.0], color: 'var(--range-red-low)' },
  { range: [7.0, 8.0], color: 'var(--range-red-high)' },
  { range: [6.0, 7.0], color: 'var(--range-red-low)' },
  { range: [5.0, 6.0], color: 'var(--range-red-low)' },
  { range: [4.0, 5.0], color: 'var(--range-yellow-high)' },
  { range: [3.0, 4.0], color: 'var(--range-yellow-low)' },
  { range: [2.0, 3.0], color: 'var(--range-green-high)' },
  { range: [1.0, 2.0], color: 'var(--range-green-high)' },
  { range: [0.0, 1.0], color: 'var(--range-green-low)' },
];

const doubleTimeHoursVariabilityCumRanges = [
  { range: [9.0, 33.0], color: 'var(--range-red-low)' },
  { range: [8.0, 9.0], color: 'var(--range-yellow-medium)' },
  { range: [7.0, 8.0], color: 'var(--range-red-low)' },
  { range: [6.0, 7.0], color: 'var(--range-red-low)' },
  { range: [5.0, 6.0], color: 'var(--range-red-high)' },
  { range: [4.0, 5.0], color: 'var(--range-yellow-medium)' },
  { range: [3.0, 4.0], color: 'var(--range-green-low)' },
  { range: [2.0, 3.0], color: 'var(--range-green-medium)' },
  { range: [0.0, 2.0], color: 'var(--range-green-high)' },
];

const overTimeHoursVariabilityCumRanges = [
  { range: [7.0, 25.0], color: 'var(--range-red-medium)' },
  { range: [6.0, 7.0], color: 'var(--range-yellow-high)' },
  { range: [5.0, 6.0], color: 'var(--range-yellow-medium)' },
  { range: [3.0, 5.0], color: 'var(--range-red-low)' },
  { range: [2.0, 3.0], color: 'var(--range-green-low)' },
  { range: [0.0, 2.0], color: 'var(--range-green-high)' },
];

const totalHoursVariabilityCumRanges = [
  { range: [4.0, 28.0], color: 'var(--range-yellow-high)' },
  { range: [3.0, 4.0], color: 'var(--range-red-low)' },
  { range: [2.0, 3.0], color: 'var(--range-red-high)' },
  { range: [1.0, 2.0], color: 'var(--range-green-low)' },
  { range: [0.0, 1.0], color: 'var(--range-green-medium)' },
];

const otherSkillsScoreRanges: RangeColor[] = [];

const safetySkillsScoreRanges: RangeColor[] = [];

const technicalSkillRanges = [
  { range: [5.0, 15.0], color: 'var(--range-red-low)' },
  { range: [4.0, 5.0], color: 'var(--range-green-low)' },
  { range: [3.0, 4.0], color: 'var(--range-green-medium)' },
  { range: [2.0, 3.0], color: 'var(--range-red-medium)' },
  { range: [1.0, 2.0], color: 'var(--range-yellow-high)' },
  { range: [0, 1.0], color: 'var(--range-yellow-medium)' },
];

const totalSkillCountRanges = [
  { range: [6.0, 17.0], color: 'var(--range-red-low)' },
  { range: [5.0, 6.0], color: 'var(--range-yellow-high)' },
  { range: [4.0, 5.0], color: 'var(--range-yellow-low)' },
  { range: [3.0, 4.0], color: 'var(--range-green-low)' },
  { range: [2.0, 3.0], color: 'var(--range-red-medium)' },
  { range: [1.0, 2.0], color: 'var(--range-yellow-high)' },
  { range: [0.0, 1.0], color: 'var(--range-yellow-low)' },
];

const averageEvaluationScoreRanges: RangeColor[] = [];

const medianEvaluationScoreRanges: RangeColor[] = [];

const evaluationScoreVariabilityRanges: RangeColor[] = [];

const uniqueEvaluationCountRanges: RangeColor[] = [];

const ageRanges = [
  { range: [63.0, 86.0], color: 'var(--range-yellow-medium)' },
  { range: [59.0, 63.0], color: 'var(--range-red-low)' },
  { range: [56.0, 69.0], color: 'var(--range-yellow-high)' },
  { range: [54.0, 56.0], color: 'var(--range-green-medium)' },
  { range: [51.0, 54.0], color: 'var(--range-green-high)' },
  { range: [48.0, 51.0], color: 'var(--range-yellow-low)' },
  { range: [45.0, 48.0], color: 'var(--range-yellow-low)' },
  { range: [42.0, 45.0], color: 'var(--range-green-low)' },
  { range: [39.0, 42.0], color: 'var(--range-green-medium)' },
  { range: [37.0, 39.0], color: 'var(--range-yellow-high)' },
  { range: [34.0, 37.0], color: 'var(--range-yellow-high)' },
  { range: [31.0, 34.0], color: 'var(--range-yellow-medium)' },
  { range: [28.0, 31.0], color: 'var(--range-yellow-medium)' },
  { range: [24.0, 28.0], color: 'var(--range-yellow-low)' },
  { range: [0, 24.0], color: 'var(--range-red-medium)' },
];

const riskScoreBasedonSimilarityRanges = [
  { range: [311, 371], color: 'var(--range-red-high)' },
  { range: [300, 311], color: 'var(--range-red-high)' },
  { range: [293, 300], color: 'var(--range-red-low)' },
  { range: [286, 293], color: 'var(--range-yellow-high)' },
  { range: [280, 286], color: 'var(--range-red-low)' },
  { range: [274, 280], color: 'var(--range-yellow-high)' },
  { range: [269, 274], color: 'var(--range-yellow-medium)' },
  { range: [263, 269], color: 'var(--range-yellow-medium)' },
  { range: [256, 263], color: 'var(--range-yellow-medium)' },
  { range: [250, 256], color: 'var(--range-green-low)' },
  { range: [243, 250], color: 'var(--range-green-low)' },
  { range: [234, 243], color: 'var(--range-green-low)' },
  { range: [223, 234], color: 'var(--range-green-low)' },
  { range: [207, 223], color: 'var(--range-green-medium)' },
  { range: [112, 207], color: 'var(--range-green-medium)' },
  { range: [0, 112], color: 'var(--range-green-high)' },
];

const warningCountRanges: RangeColor[] = [];

const cumulativeWarningCountRanges = [
  { range: [1.0, 110.0], color: 'var(--range-green-low)' },
  { range: [0, 1.0], color: 'var(--range-yellow-medium)' },
];

const totalHoursWorkedRanges = [
  { range: [25.0, 52.0], color: 'var(--range-green-low)' },
  { range: [24.0, 25.0], color: 'var(--range-yellow-low)' },
  { range: [20.0, 24.0], color: 'var(--range-red-high)' },
  { range: [16.0, 20.0], color: 'var(--range-green-medium)' },
  { range: [12.5, 16.0], color: 'var(--range-green-high)' },
  { range: [12.0, 12.5], color: 'var(--range-green-high)' },
  { range: [10.0, 12.0], color: 'var(--range-green-medium)' },
  { range: [0, 10.0], color: 'var(--range-green-high)' },
];

const totalWeightedRiskScoreRanges = [
  { range: [635.77, 866666.67], color: 'var(--range-red-high)' },
  { range: [420.32, 635.77], color: 'var(--range-red-low)' },
  { range: [348.35, 420.32], color: 'var(--range-yellow-high)' },
  { range: [277.72, 348.35], color: 'var(--range-yellow-high)' },
  { range: [216.15, 277.72], color: 'var(--range-yellow-medium)' },
  { range: [149.77, 216.15], color: 'var(--range-yellow-medium)' },
  { range: [93.55, 149.77], color: 'var(--range-green-low)' },
  { range: [44.03, 93.55], color: 'var(--range-green-low)' },
  { range: [0, 44.03], color: 'var(--range-yellow-medium)' },
];

const weightedAverageRiskLevelRanges = [
  { range: [29.24, 33333.33], color: 'var(--range-red-high)' },
  { range: [19.87, 29.24], color: 'var(--range-red-low)' },
  { range: [16.1, 19.87], color: 'var(--range-yellow-medium)' },
  { range: [13.84, 16.1], color: 'var(--range-yellow-high)' },
  { range: [11.64, 13.84], color: 'var(--range-green-low)' },
  { range: [9.32, 11.64], color: 'var(--range-green-low)' },
  { range: [6.79, 9.32], color: 'var(--range-yellow-medium)' },
  { range: [4.06, 6.79], color: 'var(--range-green-low)' },
  { range: [0, 4.06], color: 'var(--range-yellow-medium)' },
];

const monthRanges = [
  { range: [11.0, 12.0], color: 'var(--range-green-high)' },
  { range: [10.0, 11.0], color: 'var(--range-yellow-high)' },
  { range: [9.0, 10.0], color: 'var(--range-yellow-medium)' },
  { range: [7.0, 9.0], color: 'var(--range-green-low)' },
  { range: [5.0, 7.0], color: 'var(--range-green-medium)' },
  { range: [4.0, 5.0], color: 'var(--range-yellow-high)' },
  { range: [3.0, 4.0], color: 'var(--range-red-low)' },
  { range: [2.0, 3.0], color: 'var(--range-red-high)' },
  { range: [0.0, 2.0], color: 'var(--range-green-low)' },
];

const dayOfWeekRanges = [
  { range: [5.0, 6.0], color: 'var(--range-red-low)' },
  { range: [4.0, 5.0], color: 'var(--range-red-medium)' },
  { range: [3.0, 4.0], color: 'var(--range-green-low)' },
  { range: [2.0, 3.0], color: 'var(--range-yellow-medium)' },
  { range: [1.0, 2.0], color: 'var(--range-yellow-medium)' },
  { range: [0, 1.0], color: 'var(--range-green-medium)' },
];

const injuriesLast6MonthsRanges: RangeColor[] = [];

const warningsLast6MonthsRanges = [
  { range: [3.0, 94.0], color: 'var(--range-green-medium)' },
  { range: [2.0, 3.0], color: 'var(--range-yellow-medium)' },
  { range: [1.0, 2.0], color: 'var(--range-yellow-medium)' },
  { range: [0, 1.0], color: 'var(--range-red-medium)' },
];

export const regularHoursLast6MonthsRanges = [
  { range: [1268.0, 4448.0], color: 'var(--range-green-low)' },
  { range: [1080.0, 1268.0], color: 'var(--range-yellow-low)' },
  { range: [980.0, 1080.0], color: 'var(--range-green-medium)' },
  { range: [900.0, 980.0], color: 'var(--range-green-high)' },
  { range: [820.0, 900.0], color: 'var(--range-yellow-medium)' },
  { range: [740.0, 820.0], color: 'var(--range-yellow-medium)' },
  { range: [661.0, 740.0], color: 'var(--range-green-low)' },
  { range: [584.0, 661.0], color: 'var(--range-yellow-medium)' },
  { range: [512.0, 584.0], color: 'var(--range-green-low)' },
  { range: [432.0, 512.0], color: 'var(--range-yellow-high)' },
  { range: [352.0, 432.0], color: 'var(--range-yellow-medium)' },
  { range: [264.0, 352.0], color: 'var(--range-yellow-high)' },
  { range: [176.0, 264.0], color: 'var(--range-red-high)' },
  { range: [80.0, 176.0], color: 'var(--range-red-high)' },
  { range: [0, 80.0], color: 'var(--range-red-low)' },
];

const averageRegularHoursLast6MonthsRanges = [
  { range: [15.0, 48.0], color: 'var(--range-red-high)' },
  { range: [13.0, 15.0], color: 'var(--range-red-low)' },
  { range: [12.0, 13.0], color: 'var(--range-yellow-high)' },
  { range: [11.0, 12.0], color: 'var(--range-yellow-high)' },
  { range: [10.0, 11.0], color: 'var(--range-yellow-medium)' },
  { range: [8.0, 10.0], color: 'var(--range-yellow-medium)' },
  { range: [7.0, 8.0], color: 'var(--range-green-low)' },
  { range: [6.0, 7.0], color: 'var(--range-green-high)' },
  { range: [0, 6.0], color: 'var(--range-green-medium)' },
];

const doubleTimeHoursLast6MonthsRanges = [
  { range: [448.0, 1166.0], color: 'var(--range-green-high)' },
  { range: [268.0, 348.0], color: 'var(--range-green-low)' },
  { range: [221.0, 268.0], color: 'var(--range-green-high)' },
  { range: [190.0, 221.0], color: 'var(--range-green-medium)' },
  { range: [161.0, 190.0], color: 'var(--range-green-medium)' },
  { range: [139.0, 161.0], color: 'var(--range-yellow-medium)' },
  { range: [120.0, 139.0], color: 'var(--range-yellow-high)' },
  { range: [96.0, 120.0], color: 'var(--range-green-low)' },
  { range: [76.0, 96.0], color: 'var(--range-red-low)' },
  { range: [64.0, 76.0], color: 'var(--range-red-low)' },
  { range: [48.0, 64.0], color: 'var(--range-yellow-high)' },
  { range: [24.0, 48.0], color: 'var(--range-red-low)' },
  { range: [16.0, 24.0], color: 'var(--range-red-high)' },
  { range: [0, 16.0], color: 'var(--range-green-medium)' },
];

const averageDoubleTimeHoursLast6MonthsRanges = [
  { range: [4.0, 48.0], color: 'var(--range-yellow-medium)' },
  { range: [3.0, 4.0], color: 'var(--range-green-medium)' },
  { range: [2.0, 3.0], color: 'var(--range-red-high)' },
  { range: [1.0, 2.0], color: 'var(--range-yellow-high)' },
  { range: [0.0, 1.0], color: 'var(--range-green-high)' },
];

const overTimeHoursLast6MonthsRanges = [
  { range: [823.0, 2206.0], color: 'var(--range-green-medium)' },
  { range: [689.0, 823.0], color: 'var(--range-green-medium)' },
  { range: [591.0, 689.0], color: 'var(--range-green-high)' },
  { range: [512.0, 591.0], color: 'var(--range-green-medium)' },
  { range: [444.0, 512.0], color: 'var(--range-green-medium)' },
  { range: [385.0, 444.0], color: 'var(--range-yellow-low)' },
  { range: [334.0, 385.0], color: 'var(--range-yellow-high)' },
  { range: [289.0, 334.0], color: 'var(--range-yellow-medium)' },
  { range: [245.0, 289.0], color: 'var(--range-yellow-low)' },
  { range: [202.0, 245.0], color: 'var(--range-yellow-medium)' },
  { range: [160.0, 202.0], color: 'var(--range-yellow-high)' },
  { range: [117.0, 160.0], color: 'var(--range-yellow-high)' },
  { range: [72.0, 117.0], color: 'var(--range-yellow-high)' },
  { range: [24.0, 72.0], color: 'var(--range-red-high)' },
  { range: [0, 24.0], color: 'var(--range-yellow-high)' },
];

const averageOverTimeHoursLast6MonthsRanges = [
  { range: [9.0, 28.0], color: 'var(--range-red-high)' },
  { range: [8.0, 9.0], color: 'var(--range-red-low)' },
  { range: [7.0, 8.0], color: 'var(--range-yellow-high)' },
  { range: [6.0, 7.0], color: 'var(--range-yellow-medium)' },
  { range: [5.0, 6.0], color: 'var(--range-yellow-medium)' },
  { range: [4.0, 5.0], color: 'var(--range-red-low)' },
  { range: [3.0, 4.0], color: 'var(--range-green-low)' },
  { range: [2.0, 3.0], color: 'var(--range-green-medium)' },
  { range: [1.0, 2.0], color: 'var(--range-green-medium)' },
  { range: [0, 1.0], color: 'var(--range-green-high)' },
];

const averageEvaluationScoreLast6MonthsRanges: RangeColor[] = [];

const regularHoursLast30DaysRanges = [
  { range: [336.0, 728.0], color: 'var(--range-green-low)' },
  { range: [320.0, 336.0], color: 'var(--range-green-low)' },
  { range: [304.0, 320.0], color: 'var(--range-yellow-medium)' },
  { range: [288.0, 304.0], color: 'var(--range-yellow-high)' },
  { range: [256.0, 288.0], color: 'var(--range-red-low)' },
  { range: [224.0, 256.0], color: 'var(--range-red-low)' },
  { range: [186.0, 224.0], color: 'var(--range-red-medium)' },
  { range: [168.0, 186.0], color: 'var(--range-green-low)' },
  { range: [160.0, 168.0], color: 'var(--range-green-high)' },
  { range: [144.0, 160.0], color: 'var(--range-yellow-medium)' },
  { range: [128.0, 144.0], color: 'var(--range-yellow-medium)' },
  { range: [96.0, 128.0], color: 'var(--range-yellow-high)' },
  { range: [72.0, 96.0], color: 'var(--range-yellow-high)' },
  { range: [40.0, 72.0], color: 'var(--range-red-low)' },
  { range: [0, 40.0], color: 'var(--range-green-low)' },
];

const doubleTimeHoursLast30DaysRanges = [
  { range: [106.0, 323.0], color: 'var(--range-green-low)' },
  { range: [92.0, 106.0], color: 'var(--range-yellow-high)' },
  { range: [72.0, 92.0], color: 'var(--range-yellow-medium)' },
  { range: [60.0, 72.0], color: 'var(--range-red-low)' },
  { range: [48.0, 60.0], color: 'var(--range-green-medium)' },
  { range: [46.0, 48.0], color: 'var(--range-red-high)' },
  { range: [32.0, 46.0], color: 'var(--range-yellow-medium)' },
  { range: [24.0, 32.0], color: 'var(--range-green-medium)' },
  { range: [16.0, 24.0], color: 'var(--range-red-low)' },
  { range: [3.0, 16.0], color: 'var(--range-green-high)' },
  { range: [0, 3.0], color: 'var(--range-yellow-high)' },
];

const overTimeHoursLast30DaysRanges = [
  { range: [248.0, 542.0], color: 'var(--range-yellow-low)' },
  { range: [217.0, 248.0], color: 'var(--range-green-medium)' },
  { range: [192.0, 217.0], color: 'var(--range-green-low)' },
  { range: [166.0, 192.0], color: 'var(--range-yellow-low)' },
  { range: [144.0, 166.0], color: 'var(--range-yellow-high)' },
  { range: [125.0, 144.0], color: 'var(--range-yellow-medium)' },
  { range: [108.0, 125.0], color: 'var(--range-red-low)' },
  { range: [90.0, 108.0], color: 'var(--range-green-low)' },
  { range: [73.5, 90.0], color: 'var(--range-yellow-high)' },
  { range: [58.5, 73.5], color: 'var(--range-red-low)' },
  { range: [42.0, 58.5], color: 'var(--range-yellow-low)' },
  { range: [27.0, 42.0], color: 'var(--range-red-medium)' },
  { range: [12.0, 27.0], color: 'var(--range-red-high)' },
  { range: [0, 12.0], color: 'var(--range-green-high)' },
];

const totalHoursLast30DaysRanges = [
  { range: [663.0, 1328.0], color: 'var(--range-green-low)' },
  { range: [607.0, 663.0], color: 'var(--range-green-low)' },
  { range: [553.0, 607.0], color: 'var(--range-green-low)' },
  { range: [504.0, 553.0], color: 'var(--range-yellow-high)' },
  { range: [448.0, 504.0], color: 'var(--range-red-medium)' },
  { range: [384.0, 448.0], color: 'var(--range-yellow-high)' },
  { range: [336.0, 384.0], color: 'var(--range-red-low)' },
  { range: [296.0, 336.0], color: 'var(--range-red-low)' },
  { range: [259.0, 296.0], color: 'var(--range-red-low)' },
  { range: [222.0, 259.0], color: 'var(--range-yellow-medium)' },
  { range: [188.5, 222.0], color: 'var(--range-yellow-medium)' },
  { range: [156.5, 188.5], color: 'var(--range-green-low)' },
  { range: [112.0, 156.5], color: 'var(--range-yellow-medium)' },
  { range: [60.0, 112.0], color: 'var(--range-red-medium)' },
  { range: [0.0, 60.0], color: 'var(--range-green-high)' },
];

const regularHoursLast90DaysRanges = [
  { range: [816.0, 1904.0], color: 'var(--range-green-high)' },
  { range: [688.0, 816.0], color: 'var(--range-yellow-medium)' },
  { range: [583.0, 688.0], color: 'var(--range-green-low)' },
  { range: [512.0, 583.0], color: 'var(--range-green-low)' },
  { range: [468.0, 512.0], color: 'var(--range-green-medium)' },
  { range: [427.0, 468.0], color: 'var(--range-green-low)' },
  { range: [384.0, 427.0], color: 'var(--range-yellow-high)' },
  { range: [334.5, 384.0], color: 'var(--range-yellow-high)' },
  { range: [288.0, 334.5], color: 'var(--range-green-medium)' },
  { range: [240.0, 288.0], color: 'var(--range-yellow-high)' },
  { range: [192.0, 240.0], color: 'var(--range-red-low)' },
  { range: [148.0, 192.0], color: 'var(--range-yellow-medium)' },
  { range: [104.0, 148.0], color: 'var(--range-red-high)' },
  { range: [57.0, 104.0], color: 'var(--range-red-low)' },
  { range: [0, 57.0], color: 'var(--range-yellow-medium)' },
];

const doubleTimeLast90DaysRanges = [
  { range: [213.0, 841.0], color: 'var(--range-green-high)' },
  { range: [160.0, 213.0], color: 'var(--range-green-medium)' },
  { range: [127.0, 160.0], color: 'var(--range-yellow-low)' },
  { range: [105.0, 127.0], color: 'var(--range-yellow-medium)' },
  { range: [91.0, 105.0], color: 'var(--range-yellow-low)' },
  { range: [72.0, 91.0], color: 'var(--range-red-low)' },
  { range: [60.0, 72.0], color: 'var(--range-yellow-high)' },
  { range: [48.0, 60.0], color: 'var(--range-green-low)' },
  { range: [40.0, 48.0], color: 'var(--range-red-low)' },
  { range: [24.0, 40.0], color: 'var(--range-green-high)' },
  { range: [10.0, 24.0], color: 'var(--range-red-high)' },
  { range: [0, 10.0], color: 'var(--range-red-low)' },
];

const overTimeLast90DaysRanges = [
  { range: [520.0, 1138.0], color: 'var(--range-yellow-low)' },
  { range: [424.0, 520.0], color: 'var(--range-green-low)' },
  { range: [354.0, 424.0], color: 'var(--range-green-low)' },
  { range: [300.0, 354.0], color: 'var(--range-green-low)' },
  { range: [254.0, 300.0], color: 'var(--range-yellow-medium)' },
  { range: [216.0, 254.0], color: 'var(--range-green-medium)' },
  { range: [184.0, 216.0], color: 'var(--range-yellow-high)' },
  { range: [154.0, 184.0], color: 'var(--range-red-low)' },
  { range: [128.0, 154.0], color: 'var(--range-yellow-medium)' },
  { range: [101.5, 128.0], color: 'var(--range-yellow-high)' },
  { range: [76.0, 101.5], color: 'var(--range-yellow-high)' },
  { range: [52.0, 76.0], color: 'var(--range-red-low)' },
  { range: [26.0, 52.0], color: 'var(--range-red-high)' },
  { range: [4.0, 26.0], color: 'var(--range-red-low)' },
  { range: [0, 4.0], color: 'var(--range-green-high)' },
];

const totalHoursLast90DaysRanges = [
  { range: [1495.0, 3162.0], color: 'var(--range-green-medium)' },
  { range: [1252.0, 1495.0], color: 'var(--range-green-medium)' },
  { range: [1056.5, 1252.0], color: 'var(--range-yellow-medium)' },
  { range: [905.5, 1056.5], color: 'var(--range-green-low)' },
  { range: [790.0, 905.5], color: 'var(--range-green-medium)' },
  { range: [696.496, 790.0], color: 'var(--range-yellow-medium)' },
  { range: [616.5, 696.496], color: 'var(--range-yellow-medium)' },
  { range: [545.25, 616.5], color: 'var(--range-yellow-medium)' },
  { range: [478.0, 545.25], color: 'var(--range-green-low)' },
  { range: [403.0, 478.0], color: 'var(--range-yellow-medium)' },
  { range: [322.5, 403.0], color: 'var(--range-yellow-high)' },
  { range: [241.0, 322.5], color: 'var(--range-red-low)' },
  { range: [162.0, 241.0], color: 'var(--range-red-high)' },
  { range: [83.0, 162.0], color: 'var(--range-red-low)' },
  { range: [0, 83.0], color: 'var(--range-green-low)' },
];

export const kpisRanges = [
  regularHoursLoggedRanges,
  doubleTimeHoursLoggedRanges,
  overtimeHoursLoggedRanges,
  totalHoursLoggedRanges,
  workedDayShiftRanges,
  workedNightShiftRanges,
  cumulativeRegularHoursRanges,
  cumulativeDoubleTimeHoursRanges,
  cumulativeOverTimeHoursRanges,
  cumulativeTotalHoursRanges,
  averageRegularHoursCumRanges,
  averageDoubleTimeHoursCumRanges,
  averageOverTimeHoursCumRanges,
  averageTotalHoursCumRanges,
  regularHoursVariabilityCumRanges,
  doubleTimeHoursVariabilityCumRanges,
  overTimeHoursVariabilityCumRanges,
  totalHoursVariabilityCumRanges,
  otherSkillsScoreRanges,
  safetySkillsScoreRanges,
  technicalSkillRanges,
  totalSkillCountRanges,
  averageEvaluationScoreRanges,
  medianEvaluationScoreRanges,
  evaluationScoreVariabilityRanges,
  uniqueEvaluationCountRanges,
  ageRanges,
  riskScoreBasedonSimilarityRanges,
  warningCountRanges,
  cumulativeWarningCountRanges,
  totalHoursWorkedRanges,
  totalWeightedRiskScoreRanges,
  weightedAverageRiskLevelRanges,
  monthRanges,
  dayOfWeekRanges,
  injuriesLast6MonthsRanges,
  warningsLast6MonthsRanges,
  regularHoursLast6MonthsRanges,
  averageRegularHoursLast6MonthsRanges,
  doubleTimeHoursLast6MonthsRanges,
  averageDoubleTimeHoursLast6MonthsRanges,
  overTimeHoursLast6MonthsRanges,
  averageOverTimeHoursLast6MonthsRanges,
  averageEvaluationScoreLast6MonthsRanges,
  regularHoursLast30DaysRanges,
  doubleTimeHoursLast30DaysRanges,
  overTimeHoursLast30DaysRanges,
  totalHoursLast30DaysRanges,
  regularHoursLast90DaysRanges,
  doubleTimeLast90DaysRanges,
  overTimeLast90DaysRanges,
  totalHoursLast90DaysRanges,
];
